import styled from 'styled-components';


export const Wrapper = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    padding-left: 2rem;
    padding-right: 2rem;
    color: white;
`;